import React, { Component } from 'react'
import TopNavbar from '../components/TopNavbar'
import MainLinks from '../components/MainLinks'
import MainBlock from '../components/MainBlock'
import Footer from '../components/Footer'

export default class Home extends Component {
    render() {
        return (
            <div>
                <TopNavbar></TopNavbar>
                <MainLinks></MainLinks>
                <MainBlock></MainBlock>
                <Footer></Footer>
            </div>
        );
    }
}